// extracted by mini-css-extract-plugin
module.exports = {"word":"Word_word__2_cxz","image":"Word_image__1ZRpF"};